import React from 'react';
import './Page.css';

const faq = props => (
            <div className="page faq">
                <h1>Frequently Asked Questions</h1>
                <p className="page__q">Do you offer delivery or pickup of your RVs?</p>
                <p className="page__a">Yes, we offer delivery or pickup for all of our rental units for an additional fee. </p>

                <p className="page__q">Do you allow smoking in your RVs?</p>
                <p className="page__a">No, all of our rental units are strictly smoke-free.</p>

                <p className="page__q">Do you allow pets in your RVs?</p>
                <p className="page__a">No, due to allergy concerns of all of our guests, we do not allow pets of any kind in our rental units.</p>

                <p className="page__q">Is there a minimum rental commitment?</p>
                <p className="page__a">Yes, each reservation has a minimum rental commitment of two (2) nights.</p>

                <p className="page__q">How many miles are included with the rental?</p>
                <p className="page__a">We allow unlimited mileage for our rental units. However, the Sundance unit is set up for delivery only; it cannot be towed by customers.</p>

                <p className="page__q">How much is your deposit?</p>
                <p className="page__a">All reservations require a $500 security deposit via credit card. The deposit is refundable at the end of the rental, provided the unit comes back in the same condition it left in, and provided there is no damage.</p>

                <p className="page__q">Where can I learn how to operate the various components on the RV?</p>
                <p className="page__a">We will provide a complete overview on how to use the RV and all of its components. Each renter is required to go through the thorough walkthrough before each rental begins.</p>

            </div>
);

export default faq;